// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact__Ei4p0","vendorValidation":"vendorValidation__DLOmU","confidenceAppend":"confidenceAppend__jSojM"};